import React from "react";
import moment from "moment";
import { Comment, Image, Input } from "semantic-ui-react";

// Audio Player Function that appears in chat area
const Audio = ({ src }) => {
  const [current, setCurrent] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [playing, setPlaying] = React.useState(false);
  return (
    <>
      <br />
      <br />
      <audio style={{ height: "20px" }} src={src} controls />
    </>
  );
};

// Function that check which user's message it is
const isOwnMessage = (message, user) => {
  return message.user.id === user.uid ? "message_self" : "";
};

// Checks if message is Image
const isImage = (message) => {
  return message.hasOwnProperty("image") && !message.hasOwnProperty("content");
};

// Checks if message is Audio
const isAudio = (message) => {
  return 0 <= new String(message.image).search(/.mp3/i);
};

// Uses moment library for message timestamp
const timeFromNow = (timestamp) => moment(timestamp).fromNow();

// Message Component that is reusable and used in other components
const Message = ({ message, user }) => (
  <Comment>
    <Comment.Avatar src={message.user.avatar} />
    <Comment.Content className={isOwnMessage(message, user)}>
      <Comment.Author as="a">{message.user.name}</Comment.Author>
      <Comment.Metadata>{timeFromNow(message.timestamp)}</Comment.Metadata>
      {isImage(message) ? (
        isAudio(message) ? (
          <Audio src={message.image} />
        ) : (
          <Image src={message.image} className="message_image" />
        )
      ) : (
        <Comment.Text>{message.content}</Comment.Text>
      )}
    </Comment.Content>
  </Comment>
);

export default Message;
